<template>
  <svg
    width="24"
    height="27"
    viewBox="0 0 24 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.79021 0L1.7124 6.79638V10.2663H3.20243V7.79032H8.87601V1.44925H20.7933V10.2666H22.286V0.000575296L7.79021 0Z"
      fill="currentcolor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.20257 20.8527H20.7938V25.5506L3.20257 25.5338V20.8527ZM9.0065 13.2598C9.93217 13.2619 10.8564 13.253 11.7794 13.2646C12.5159 13.2935 13.2019 13.792 13.416 14.4783C13.6631 15.2081 13.4762 16.1271 12.8015 16.582C12.3941 16.8789 11.8754 16.939 11.3817 16.9211H10.2458V19.0091H9.00637L9.0065 13.2598ZM6.66373 13.2577H7.90493V17.458C7.90493 17.9833 7.74215 18.4072 7.41299 18.7318C7.08639 19.0488 6.60188 19.209 5.95898 19.209C5.38266 19.209 4.93289 19.0598 4.61336 18.7672C4.29126 18.4655 4.13053 18.0196 4.13053 17.4248L4.1304 16.8344H5.25525V17.3627C5.25525 17.9345 5.48567 18.2301 5.95924 18.2301C6.56357 18.2301 6.6636 17.7909 6.6636 17.3469L6.66373 13.2577ZM17.184 13.0669C17.6273 13.0596 18.071 13.138 18.4774 13.2974C19.214 13.5773 19.8059 14.2538 19.8581 15.0326H18.6099C18.5093 14.383 17.7664 14.0098 17.1357 14.0698C16.4866 14.0919 15.9379 14.5823 15.7641 15.1724C15.5653 15.8536 15.5517 16.6192 15.8532 17.2736C16.096 17.8355 16.7012 18.2454 17.3388 18.1929C18.0385 18.1793 18.6968 17.6046 18.7086 16.9106V16.8769H17.399V15.9166H19.8678V19.0069H18.8434C18.8341 18.8161 18.8254 18.6253 18.8157 18.4343C18.4567 19.0227 17.7022 19.2072 17.0422 19.2072C16.3746 19.2225 15.7229 18.9383 15.266 18.4727C14.4518 17.656 14.21 16.4196 14.436 15.3308C14.598 14.5073 15.1052 13.7175 15.9054 13.3583C16.3036 13.1712 16.7425 13.0757 17.184 13.0669ZM0 11.4134V20.8521H1.71258V26.9804L22.2857 27V20.8526H24V11.4132L0 11.4134Z"
      fill="currentcolor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.3545 14.2538C11.1574 14.2517 10.9613 14.2628 10.7664 14.2538H10.2459V15.9425H11.4221C11.7755 15.9531 12.1814 15.847 12.3376 15.5076C12.5504 15.0969 12.4078 14.4915 11.9303 14.3296C11.7429 14.2692 11.5481 14.2559 11.3545 14.2538Z"
      fill="currentcolor"
    />
  </svg>
</template>
